'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

/* Stores */

var _storesModuleInspector = require('stores/module-inspector');

var _storesModuleInspector2 = _interopRequireDefault(_storesModuleInspector);

/* Components */

var _componentsUiTitledGroup = require('components/ui/titled-group');

var _componentsUiTitledGroup2 = _interopRequireDefault(_componentsUiTitledGroup);

var _typeMultiGroup = require('./type/multi-group');

var _typeMultiGroup2 = _interopRequireDefault(_typeMultiGroup);

var _typeGroup = require('./type/group');

var _typeGroup2 = _interopRequireDefault(_typeGroup);

var _typeText = require('./type/text');

var _typeText2 = _interopRequireDefault(_typeText);

var _typeTextArea = require('./type/text-area');

var _typeTextArea2 = _interopRequireDefault(_typeTextArea);

var _typeMultiText = require('./type/multi-text');

var _typeMultiText2 = _interopRequireDefault(_typeMultiText);

var _typeNumber = require('./type/number');

var _typeNumber2 = _interopRequireDefault(_typeNumber);

var _typeDate = require('./type/date');

var _typeDate2 = _interopRequireDefault(_typeDate);

var _typeCheckbox = require('./type/checkbox');

var _typeCheckbox2 = _interopRequireDefault(_typeCheckbox);

var _typeButton = require('./type/button');

var _typeButton2 = _interopRequireDefault(_typeButton);

var _typeButtonGroup = require('./type/button-group');

var _typeButtonGroup2 = _interopRequireDefault(_typeButtonGroup);

var _typeSelect = require('./type/select');

var _typeSelect2 = _interopRequireDefault(_typeSelect);

var _typeDatasource = require('./type/datasource');

var _typeDatasource2 = _interopRequireDefault(_typeDatasource);

var _typeColor = require('./type/color');

var _typeColor2 = _interopRequireDefault(_typeColor);

var _typeImage = require('./type/image');

var _typeImage2 = _interopRequireDefault(_typeImage);

var _typeTranslationCollection = require('./type/translation-collection');

var _typeTranslationCollection2 = _interopRequireDefault(_typeTranslationCollection);

var componentTypes = {
  'multi-group': _typeMultiGroup2['default'],
  'group': _typeGroup2['default'],
  'text': _typeText2['default'],
  'textarea': _typeTextArea2['default'],
  'multi-text': _typeMultiText2['default'],
  'number': _typeNumber2['default'],
  'date': _typeDate2['default'],
  'button-group': _typeButtonGroup2['default'],
  'button': _typeButton2['default'],
  'select': _typeSelect2['default'],
  'datasource': _typeDatasource2['default'],
  'checkbox': _typeCheckbox2['default'],
  'color': _typeColor2['default'],
  'image': _typeImage2['default'],
  'translation-collection': _typeTranslationCollection2['default']
};

exports['default'] = _react2['default'].createClass({
  displayName: 'property',

  render: function render() {
    var props = this.props;

    var translate = _storesModuleInspector2['default'].translate;
    var hasTranslation = _storesModuleInspector2['default'].hasTranslation;

    var NodeComponent = componentTypes[props.type];

    if (!NodeComponent) {
      console.error('Unknown module property type', props.type);
      var failedTitle = translate(props.propertyGroupName + '_group_' + props.name);
      return _react2['default'].createElement(
        _componentsUiTitledGroup2['default'],
        {
          title: failedTitle,
          className: 'failed-to-load-property-component' },
        'Failed to load'
      );
    }

    var groupName = props.propertyGroupName + '_group';
    var descriptionName = groupName + '_' + props.name + '_description';
    var showDescription = hasTranslation(descriptionName);
    var descriptionText = translate(descriptionName);

    var descriptionNode = null;

    if (showDescription) {
      descriptionNode = _react2['default'].createElement(
        'div',
        { className: 'description' },
        descriptionText
      );
    }

    return _react2['default'].createElement(
      'div',
      { className: 'property-component' },
      _react2['default'].createElement(NodeComponent, _extends({}, props, {
        disabled: props.disabled,
        projectId: props.projectId,
        groupName: groupName,
        onPerformAction: this._onPerformAction,
        onChange: this._onChange })),
      descriptionNode
    );
  },

  _onPerformAction: function _onPerformAction(actionName) {
    var props = this.props;
    var groupName = props.propertyGroupName;

    if (props.onPerformAction) {
      props.onPerformAction(groupName, actionName);
    }
  },

  _onChange: function _onChange(originalValue, value) {
    var props = this.props;

    if (props.onChange) {
      props.onChange(props.propertyGroupName, props.name, originalValue, value);
    }
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/property.js
 **/